import useAdmin from 'context/admin-context/hook';
import {  FC, useMemo, useNavigate } from 'external/react';

type ClientsTableSimpleRowProps = {
  clientData: any
}

const ClientsTableSimpleRow: FC<ClientsTableSimpleRowProps> = (props) => {
  const navigate = useNavigate()
  const {clientData: item} = props
  const {roleName} = useAdmin()
  const link = useMemo(() => `/${roleName?.substring(0, roleName.indexOf('_') >= 0 ? roleName.indexOf('_') : roleName.length) || 'admin'}/clients/${item.id}`, [roleName])
    return (
      <tr>
        <td className="text-capitalize" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          <a
            href={link}
            onClick={e => { e.preventDefault(); navigate(link); }}
            style={{ textDecoration: 'none' }}
          >
            {item.name}
          </a>
        </td>
        <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.email}</td>
        <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.domain}</td>
        <td className="text-center">{item.purchases}</td>
      </tr>
  );
};

export default ClientsTableSimpleRow;